import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EmptyPage from '../Elements/EmptyPage'

interface EmptyPlaylistProps {
  isLoading: boolean
}
const EmptyPlaylist: React.FunctionComponent<EmptyPlaylistProps> = (props) => {
  const { t } = useTranslation()

  return (
    <EmptyPage
      {...props}
      message={
        <Typography variant="subtitle1" component="p">
          {t('EmptyPlaylist.Message.NoPlaylistData', 'No playlists available.')}
        </Typography>
      }
    />
  )
}

export default EmptyPlaylist
